document.addEventListener('DOMContentLoaded', function () {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger);

  const animItems = [
    { selector: '.fade-in', props: { opacity: 1 } },
    { selector: '.fade-up', props: { opacity: 1, y: 0 } },
    { selector: '.fade-zoom', props: { opacity: 1, scale: 1 } },
  ];

  animItems.forEach(({ selector, props }) => {
    const targets = document.querySelectorAll(selector);
    if (targets.length === 0) return;

    targets.forEach((el) => {
      gsap.set(el, { ...Object.keys(props).reduce((acc, key) => {
        if (key === 'opacity') acc.opacity = 0;
        if (key === 'y') acc.y = 30;
        if (key === 'scale') acc.scale = 0.9;
        return acc;
      }, {}) });

      gsap.to(el, {
        ...props,
        duration: 0.8,
        ease: 'power2.out',
        delay: 0.1,
        scrollTrigger: {
          trigger: el,
          start: 'top 90%',
          toggleActions: 'play none none reverse',
        },
      });
    });
  });
});
